// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"8d5e10c6","130":"66cb041d","376":"4f77dacc","398":"cad0d31b","517":"23be1277","682":"10efb990","734":"3fed9108","825":"dc490a5c","922":"88e28774"}[chunkId] + ".chunk.js";
};